export default __webpack_public_path__ + "static/media/Shruti.78538175.ttf";